import useSWR from 'swr'

import { GITHUB_CLI_REPO_NAME, GITHUB_API_REPO_URL } from '~/constants'

import { RawRepoStargazers, RawOrgRepos } from './docs/types'

export const useRepoStargazers = (initialValue: number | undefined) => {
  const { data } = useSWR<RawRepoStargazers>(GITHUB_API_REPO_URL)

  return data ? data.stargazers_count : initialValue
}

export const getOverallStargazers = (repos: RawOrgRepos) => {
  const githubReposStargazers = repos
    .map((data) => data.stargazers_count)
    .reduce((previousValue, currentValue) => previousValue + currentValue)

  return githubReposStargazers
}

export const getHttpieRepoStargazers = (repos: RawOrgRepos) => {
  return repos.find(({ name }) => name === GITHUB_CLI_REPO_NAME)?.stargazers_count
}
